const reviewPage = {
    errorMsg: "Sie haben bereits eine Bewertung abgegeben."
};

const guestAppErrorsList = {
    reviewPage
};

export default guestAppErrorsList;
